export const loadingStatus = state => {
    return state.loadingStatus;
};

export const error = state => {
    return state.error;
};

export const successMessage = state => {
    return state.successMessage;
};

export const currentPageTitle = state => {
    return state.currentPageTitle;
};

export const userPermissions = state => {
    return state.userpermissions;
};

